export interface TokenPayload {
  id_token: string;
  access_token: string;
  refresh_token?: string;
  expires_in: number;
  token_type?: string;
}

export interface AuthUser {
  email: string;
  username: string;
}

export interface AuthSession {
  idToken: string;
  accessToken: string;
  refreshToken?: string;
  expiresAt: number;
  loginAt: number;
  user: AuthUser;
}

export interface AuthChallenge {
  challenge: 'NEW_PASSWORD_REQUIRED';
  session: string;
  email: string;
}

export interface StaffPermissions {
  clients: { view: boolean; create: boolean; edit: boolean };
  device_catalog: { create: boolean; edit: boolean };
  manufacturing_batches: { create: boolean; edit: boolean };
  manufactured_devices: {
    create: boolean;
    edit: boolean;
    telemetry_health: boolean;
    reset: boolean;
  };
  account: { edit: boolean; first_edit_available: boolean };
}

export interface StaffMe {
  staff_user_id: string;
  email: string;
  display_name?: string;
  phone?: string;
  address?: string;
  birth_date?: string;
  role: 'admin' | 'operator';
  status: string;
  permissions: StaffPermissions;
  can_edit_account: boolean;
  photo_url?: string | null;
  photo_object_key?: string | null;
}

export function emptyPermissions(): StaffPermissions {
  return {
    clients: { view: false, create: false, edit: false },
    device_catalog: { create: false, edit: false },
    manufacturing_batches: { create: false, edit: false },
    manufactured_devices: { create: false, edit: false, telemetry_health: false, reset: false },
    account: { edit: false, first_edit_available: true },
  };
}
